const ChatIcon = ({ color = '#fff', width = '22', height = '22', className }) => {

    return (
        <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 5.5h16a1 1 0 011 1V15a1 1 0 01-1 1H9.5L5 19.5V16.5H4a1 1 0 01-1-1V6.5a1 1 0 011-1z" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )

};

export default ChatIcon;
